import { cn } from "@jesus-central-church/shared";
import {
  SbBlokData,
  storyblokEditable,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";
import { SbPage } from "@storyblok/types/287435740670216/storyblok-components";
import React from "react";

interface PageProperties {
  blok: SbPage & {
    body: SbBlokData[];
  };
  pageData: {
    locale: string;
  };
}

const Page: React.FunctionComponent<PageProperties> = ({ blok, pageData }) => {
  const backgroundColorClassName = cn(
    "bg-freedom",
    blok.backgroundColor ? `bg-${blok.backgroundColor}` : "",
  );

  return (
    <div
      {...storyblokEditable(blok as SbBlokData)}
      className={backgroundColorClassName}
    >
      <main>
        {blok.body?.map((nestedBlok: SbBlokData) => (
          <StoryblokServerComponent
            blok={nestedBlok}
            key={nestedBlok._uid}
            pageData={pageData}
          />
        ))}
      </main>
    </div>
  );
};

export default Page;
